"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages_de = void 0;
exports.messages_de = {
    Address: "Die Adresse ist erforderlich",
    Province: "Die Provinz ist erforderlich",
    PostalCode: {
        required: "Die Postleitzahl ist erforderlich",
        pattern: "Die Postleitzahl hat das falsche Format",
    },
    Profiles: {
        required: "Die Art des Unternehmens ist erforderlich",
    },
    Number: "Die Nummer ist erforderlich",
    City: "Die Ortschaft ist erforderlich",
    Tariff: "Der Tarif ist erforderlich",
    ContractedPower: {
        required: "Die vereinbarte Leistung ist erforderlich",
        pattern: "Die Leistung hat das falsche Format",
    },
    Name: "Der Name ist erforderlich",
    LastName: "Der Nachname ist erforderlich",
    Email: {
        required: "Die E-Mail ist erforderlich",
        pattern: "Bitte geben Sie eine gültige E-Mail-Adresse ein. Zum Beispiel perez@dominio.com",
        email: "Bitte geben Sie eine gültige E-Mail-Adresse ein. Zum Beispiel perez@dominio.com",
    },
    referralEmployee: {
        required: "Der Name des Managers ist erforderlich",
    },
    referralEmail: {
        required: "Die E-Mail des Managers ist erforderlich",
        pattern: "Die zulässigen Domains sind endesa.com, enel.com, endesa.es und enel.es",
        email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    },
    Terms: "Die Bedingungen müssen akzeptiert werden",
    documentNumber: {
        required: "Das Dokument ist erforderlich",
        pattern: "Das Format des Dokuments ist nicht korrekt",
        nifES: "Bitte geben Sie eine gültige NIF ein",
        dniES: "Bitte geben Sie eine gültige DNI ein",
        nieES: "Bitte geben Sie eine gültige NIE ein",
    },
    PhoneNumber: {
        required: "Das Telefon ist erforderlich",
        minlength: "Das Telefon muss 9 Zahlen haben",
        number: "Das Telefon muss aus Zahlen bestehen",
        phoneNumberEs: "Das Telefonformat ist nicht korrekt",
    },
    CUPS: {
        required: "Der CUPS ist erforderlich",
        pattern: "Das Format des CUPS ist nicht korrekt",
    },
    ContactName: {
        required: "Der Name ist erforderlich",
    },
    ContactLastName: {
        required: "Der Nachname ist erforderlich",
    },
    ContactDocumentNumber: {
        required: "Das Dokument ist erforderlich",
        pattern: "Das Format des Dokuments ist nicht korrekt",
        dniES: "Bitte geben Sie eine gültige DNI ein",
        nieES: "Bitte geben Sie eine gültige NIE ein",
    },
    TotalConsumption: {
        required: "Der Verbrauch ist erforderlich",
        pattern: "Das Verbrauchsformat muss numerisch sein",
    },
};
